import React from 'react';
import ReactPlayer from 'react-player';
import { PapiroConsole } from '../../utils/papiroConsole';

/*
Player novo com <audio> nativo e placeholder de carregamento.
Deixei comentado para facilitar voltar depois do teste com ReactPlayer.

const AudioLoadingPlaceholder = ({ error }) => (
  <div className={`omnichannel-chat-message-audio-placeholder${error ? ' error' : ''}`}>
    <div className={error ? "omnichannel-chat-message-audio-error-icon" : "omnichannel-chat-message-audio-spinner"}>
      {error ? "!" : null}
    </div>
    {error ? (
      <span className="omnichannel-chat-message-audio-error-text">Audio indisponivel</span>
    ) : (
      <div className="omnichannel-chat-message-audio-waveform">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    )}
  </div>
)

const NativeAudioPlayer = ({ audioUrl }) => {
  const [audioReady, setAudioReady] = React.useState(false)
  const [audioError, setAudioError] = React.useState(false)

  React.useEffect(() => {
    setAudioReady(false)
    setAudioError(false)
    PapiroConsole.log("=== AudioPlayer ===")
    PapiroConsole.log("audioUrl")
    PapiroConsole.log(audioUrl)
  }, [audioUrl]);

  return (
    <div className="omnichannel-chat-audio-player">
      {!audioReady && <AudioLoadingPlaceholder error={audioError} />}
      <audio
        className={audioReady ? "omnichannel-chat-audio-native" : "omnichannel-chat-audio-native loading"}
        src={audioUrl}
        controls
        preload="metadata"
        onLoadedMetadata={() => {
          setAudioReady(true)
          setAudioError(false)
          PapiroConsole.log("AudioPlayer -> loaded metadata")
          PapiroConsole.log(audioUrl)
        }}
        onError={(event) => {
          setAudioReady(false)
          setAudioError(true)
          PapiroConsole.log("AudioPlayer -> audio error")
          PapiroConsole.log(event)
        }}
      />
    </div>
  );
};
*/

const AudioPlayer = ({ audioUrl }) => {
  React.useEffect(() => {
    PapiroConsole.log("=== AudioPlayer ReactPlayer antigo ===")
    PapiroConsole.log("audioUrl")
    PapiroConsole.log(audioUrl)
  }, [audioUrl]);

  return (
    <div className="omnichannel-chat-audio-player" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#CDDFE7', width: '100%', maxWidth: '100%' }}>
      <ReactPlayer
        url={audioUrl}
        controls={true}
        width="100%"
        height="40px"
        style={{ outline: 'none' }}
      />
    </div>
  );
};

export default AudioPlayer;
